export default __webpack_public_path__ + "static/media/multiple_matrix.8c81b9e9.svg";